import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClickItem", "to"];
import { CALYPSO } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UIIcon from 'UIComponents/icon/UIIcon';
import * as SuperCategoryGroup from 'marketplace-ui-apps-core/common/constants/groupTags/SuperCategoryGroup';
import { SUPER_CATEGORY_ORDER } from 'marketplace-ui-apps-core/common/constants/groupTags/SuperCategoryOrder';
import { getSuperCategoryI18nKey } from 'marketplace-ui-apps-core/common/utils/i18n';
import MobilePanel from 'marketplace-ui-common/components/mobile/MobilePanel';
import MobilePanelBody from 'marketplace-ui-common/components/mobile/MobilePanelBody';
import MobilePanelHeader from 'marketplace-ui-common/components/mobile/MobilePanelHeader';
import { MobilePanelHeaderLeftButton } from 'marketplace-ui-common/components/mobile/MobilePanelHeaderButton';
import MobilePanelNavItem from 'marketplace-ui-common/components/mobile/MobilePanelNavItem';
import { getCategoryI18nKey } from 'marketplace-ui-common/utils/i18n';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getCategoryFilterUrl, getSuperCategoryFilterUrl } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function MobilePanelRouterNavItem(_ref) {
  let {
      onClickItem,
      to
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const history = useHistory();
  return /*#__PURE__*/_jsx(MobilePanelNavItem, Object.assign({}, rest, {
    onClickItem: itemId => {
      history.push(to);
      onClickItem(itemId);
    }
  }));
}
export function MobileBrowsePanel({
  onClose,
  open
}) {
  const [openSuperCategory, setOpenSuperCategory] = useState();
  const handleClose = () => {
    setOpenSuperCategory(undefined);
    onClose();
  };
  return /*#__PURE__*/_jsxs(MobilePanel, {
    align: "bottom",
    open: open,
    children: [/*#__PURE__*/_jsx(MobilePanelHeader, {
      itemLeft: /*#__PURE__*/_jsx(MobilePanelHeaderLeftButton, {
        autoFocus: true,
        onClick: handleClose,
        tabIndex: 0,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "appMarketplace.storefront.mobileNavigation.cancel"
        })
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.mobileNavigation.browse"
      })
    }), /*#__PURE__*/_jsxs(MobilePanelBody, {
      children: [/*#__PURE__*/_jsx(MobilePanelRouterNavItem, {
        onClickItem: handleClose,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "appMarketplace.storefront.filters.category.items.all.titleText"
        }),
        to: "/"
      }), SUPER_CATEGORY_ORDER.map(superCategory => /*#__PURE__*/_jsx(MobilePanelNavItem, {
        onClickItem: () => setOpenSuperCategory(superCategory),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getSuperCategoryI18nKey(superCategory)
        }),
        children: /*#__PURE__*/_jsxs(MobilePanel, {
          open: openSuperCategory === superCategory,
          children: [/*#__PURE__*/_jsx(MobilePanelHeader, {
            itemLeft: /*#__PURE__*/_jsxs(MobilePanelHeaderLeftButton, {
              onClick: () => setOpenSuperCategory(undefined),
              children: [/*#__PURE__*/_jsx(UIIcon, {
                name: "left",
                color: CALYPSO,
                size: "xs"
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.storefront.mobileNavigation.back"
              })]
            }),
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: getSuperCategoryI18nKey(superCategory)
            })
          }), /*#__PURE__*/_jsxs(MobilePanelBody, {
            children: [/*#__PURE__*/_jsx(MobilePanelRouterNavItem, {
              onClickItem: handleClose,
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.storefront.filters.category.allSuperCategoryTitleText",
                options: {
                  superCategory: unescapedText(getSuperCategoryI18nKey(superCategory))
                }
              }),
              to: getSuperCategoryFilterUrl(superCategory)
            }), superCategory in SuperCategoryGroup && SuperCategoryGroup[superCategory].map(category => /*#__PURE__*/_jsx(MobilePanelRouterNavItem, {
              onClickItem: handleClose,
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: getCategoryI18nKey(category)
              }),
              to: getCategoryFilterUrl(category, superCategory)
            }, `${superCategory}-${category}`))]
          })]
        })
      }, superCategory))]
    })]
  });
}